import React from "react";
import { Landmark } from "lucide-react";
import { Btn } from "./ui";
import { LINKS } from "./data";

export const FinancingSection = () => (
  <section className="py-16 lg:py-24 bg-[#F5F5F5]">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="bg-white border border-[#E5E5E5] rounded-[20px] p-8 sm:p-12 lg:p-16 text-center">
        <div className="w-14 h-14 rounded-full bg-[#254369]/10 flex items-center justify-center mx-auto mb-6">
          <Landmark className="text-[#254369]" size={26} />
        </div>
        <h2 className="font-heading font-extrabold tracking-tight text-3xl sm:text-4xl leading-tight text-[#2D2D37] max-w-2xl mx-auto">
          Real Estate and Mortgage Guidance in One Place
        </h2>
        <p className="mt-6 text-base sm:text-lg leading-relaxed text-[#2D2D37]/70 max-w-2xl mx-auto">
          Buying a home is easier when your real estate and financing questions are part of the
          same conversation. Wallstreet Realty helps buyers understand their next steps before
          they move forward.
        </p>
        <div className="mt-8 flex justify-center">
          <Btn href={LINKS.buyers} variant="primary" testid="financing-guidance">
            Get Financing Guidance
          </Btn>
        </div>
      </div>
    </div>
  </section>
);
